import { IoMdMore } from "react-icons/io";
import { LuUser } from "react-icons/lu";
import { GoDotFill } from "react-icons/go";


const RoleItem =()=>{



    return(<div className="bg-whit shadow-sm border border-gray-200 rounded-[10px] flex  py-4  px-1 justify-between items-center">

 
 
<div className=" px-2">
    <p className="font-semibold text-xs">Manager</p>
    <p className="font-normal text-xs text-textbg my-1">RWNDYNAMICS Engages </p>
    <div className="flex gap-3 mt-1">


    <p className="font-light text-xs rounded-full px-1 bg-[#F0F9FF]"> Permmisions <b>12</b> </p>
    <p className="font-light text-xs rounded-full px-1 bg-[#F0F9FF]">   Users <b>8</b></p>
    </div>
 
</div>

<IoMdMore size={20} className="text-textbg "/>

    </div>
        )
}
export {RoleItem}